import { useEffect, useState } from "react";
import { useAuth } from "../../../../context/authProvider";
import { useWatches } from "../../../../context/watchProvider";
import DraftWatches from "./drafts/draftWatches";
import AdminToast from "../../../core/admin/adminToast";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import ApprovalWatches from "./approvalWatches";
import AdvertisedWatches from "./advertisedWatches";
import SoldWatches from "./soldWatches";
import HiddenWatches from "./hiddenWatches";
import { IWatch } from "../watches/adminWatches";

export default function MyWatches() {

    const { getMyWatches } = useWatches();
    const { userId } = useAuth();

    const [loading, setLoading] = useState(false);
    const [myWatches, setMyWatches] = useState<IWatch[]>([]);

    const [badToast, setBadToast] = useState(false);
    const [goodToast, setGoodToast] = useState(false);
    const [deleteToast, setDeleteToast] = useState(false);
    const [approvalToast, setApprovalToast] = useState(false);

    const doGetMyWatches = async () => {
        setLoading(true);
        if (userId) {
            const myW = await getMyWatches(userId);
            if(myW){
                setMyWatches(myW);
                setLoading(false);
                return null;
            }
        }
        setMyWatches([]);
        setLoading(false);
        setBadToast(true);
    }

    const finishCreation = () => {
        setGoodToast(true);
        doGetMyWatches();
    }

    const editOk = () => {
        setApprovalToast(true);
        doGetMyWatches();
    }

    const deleteOk = () => {
        setDeleteToast(true);
        doGetMyWatches();
    }

    useEffect(() => {
        doGetMyWatches();
        // eslint-disable-next-line
    }, []);

    return (
        <AdminPage title="Meus relógios" description="Crie rascunhos, complete as informações e envie para aprovação. Depois de aprovado, o relógio fica em exibição no site.">
            {
                loading ?
                    <AdminCard><AdminLoading /></AdminCard>
                    :
                    <div className="flex flex-col gap-6">
                        <DraftWatches watches={myWatches.filter(w => w.status === "draft")} finish={finishCreation} editOk={editOk} deleteOk={deleteOk} refresh={doGetMyWatches}/>
                        <ApprovalWatches watches={myWatches.filter(w => w.status === "approval")} refresh={doGetMyWatches}/>
                        <AdvertisedWatches watches={myWatches.filter(w => w.status === "display")} refresh={editOk}/>
                        <SoldWatches watches={myWatches.filter(w => w.status === "sold")}/>
                        <HiddenWatches watches={myWatches.filter(w => w.status === "hidden")}/>
                    </div>
            }
            <AdminToast toast={goodToast} setToast={setGoodToast} tone="success" message="Rascunho criado!"/>
            <AdminToast toast={badToast} setToast={setBadToast} message="Nenhum relógio encontrado" tone="danger"/>
            <AdminToast toast={deleteToast} setToast={setDeleteToast} message="Relógio removido!" tone="warning"/>
            <AdminToast toast={approvalToast} setToast={setApprovalToast} message="Relógio atualizado!" tone="success"/>
        </AdminPage>
    )
}
